import {WebGLRendererComponent} from '../three/renderer/webgl-renderer.component';

export abstract class ToolContainer {
   public abstract setRendererComponent(renderer: WebGLRendererComponent): void;
}
